import './App.css'
import {BrowserRouter, Navigate, Route, Routes} from "react-router";
import UXNetworkHome from "./tr3ad/ux/network/UXNetworkHome.tsx";
import UXLogin from "./tr3ad/ux/UXLogin.tsx";
import UXLoginReset from "./tr3ad/ux/UXLoginReset.tsx";
import UXRegister from "./tr3ad/ux/UXRegister.tsx";
import {createTheme, responsiveFontSizes, Stack, ThemeProvider} from "@mui/material";
import {appStyles} from "./tr3ad/AppStyles.ts";
import UXNetworkSelect from "./tr3ad/ux/network/UXNetworkSelect.tsx";
import AppHeader from "./tr3ad/ux/AppHeader.tsx";
import UXStoryboardSelect from "./tr3ad/ux/network/storyboard/UXStoryboardSelect.tsx";
import UXStoryboardCreate from "./tr3ad/ux/network/storyboard/UXStoryboardCreate.tsx";
import UXStoryboardViewer from "./tr3ad/ux/network/storyboard/UXStoryboardViewer.tsx";
import UXWorkspaceCreate from "./tr3ad/ux/network/workspace/UXWorkspaceCreate.tsx";
import UXDashboardSelect from "./tr3ad/ux/network/dashboard/UXDashboardSelect.tsx";
import UXDashboardViewer from "./tr3ad/ux/network/dashboard/UXDashboardViewer.tsx";
import UXExplorerSelect from "./tr3ad/ux/network/explorer/UXExplorerSelect.tsx";
import UXExplorerCreate from "./tr3ad/ux/network/explorer/UXExplorerCreate.tsx";
import UXExplorerViewer from "./tr3ad/ux/network/explorer/UXExplorerViewer.tsx";
import UXLocations from "./tr3ad/ux/network/location/UXLocations.tsx";
import UXReportSelect from "./tr3ad/ux/network/report/UXReportSelect.tsx";
import UXReportConfigure from "./tr3ad/ux/network/report/UXReportConfigure.tsx";
import UXReportViewer from "./tr3ad/ux/network/report/UXReportViewer.tsx";
import UXSearch from "./tr3ad/ux/network/search/UXSearch.tsx";
import UXNetworkSettings from "./tr3ad/ux/network/setting/UXNetworkSettings.tsx";
import UXNetworkTransactions from "./tr3ad/ux/network/setting/UXNetworkTransactions.tsx";
import UXTagSelect from "./tr3ad/ux/network/tag/UXTagSelect.tsx";
import UXTagViewer from "./tr3ad/ux/network/tag/UXTagViewer.tsx";
import UXAIAnalyst from "./tr3ad/ux/network/analyst/UXAIAnalyst.tsx";
import UXGraphSelect from "./tr3ad/ux/network/graph/UXGraphSelect.tsx";
import UXGraphViewer from "./tr3ad/ux/network/graph/UXGraphViewer.tsx";
import UXDiscussionSelect from "./tr3ad/ux/network/discussion/UXDiscussionSelect.tsx";
import UXDiscussionViewer from "./tr3ad/ux/network/discussion/UXDiscussionViewer.tsx";
import UXTimeline from "./tr3ad/ux/network/timeline/UXTimeline.tsx";
import UXTimelineYear from "./tr3ad/ux/network/timeline/UXTimelineYear.tsx";
import UXTimelineMonth from "./tr3ad/ux/network/timeline/UXTimelineMonth.tsx";
import UXTimelineViewer from "./tr3ad/ux/network/timeline/UXTimelineViewer.tsx";
import UXIntelManager from "./tr3ad/ux/network/intel/UXIntelManager.tsx";
import UXIntelCreate from "./tr3ad/ux/network/intel/UXIntelCreate.tsx";
import UXIntelCreateSelect from "./tr3ad/ux/network/intel/UXIntelCreateSelect.tsx";
import UXResourceManager from "./tr3ad/ux/network/resource/UXResourceManager.tsx";
import UXIntelViewer from "./tr3ad/ux/network/intel/UXIntelViewer.tsx";
import UXIntelSummaryPanel from "./tr3ad/ux/network/intel/panels/UXIntelSummaryPanel.tsx";
import UXIntelTimelinePanel from "./tr3ad/ux/network/intel/panels/UXIntelTimelinePanel.tsx";
import UXIntelDetailsPanel from "./tr3ad/ux/network/intel/panels/UXIntelDetailsPanel.tsx";
import UXIntelImagesPanel from "./tr3ad/ux/network/intel/panels/UXIntelImagesPanel.tsx";
import UXIntelWebRefsPanel from "./tr3ad/ux/network/intel/panels/UXIntelWebRefsPanel.tsx";
import UXIntelResolversPanel from "./tr3ad/ux/network/intel/panels/UXIntelResolversPanel.tsx";
import UXIntelAssociationsPanel from "./tr3ad/ux/network/intel/panels/UXIntelAssociationsPanel.tsx";
import UXIntelResourcesPanel from "./tr3ad/ux/network/intel/panels/UXIntelResourcesPanel.tsx";
import UXIntelAnalystPanel from "./tr3ad/ux/network/intel/panels/UXIntelAnalystPanel.tsx";
import UXIntelFactorsPanel from "./tr3ad/ux/network/intel/panels/UXIntelFactorsPanel.tsx";
import UXIntelEnrichmentPanel from "./tr3ad/ux/network/intel/panels/UXIntelEnrichmentPanel.tsx";
import UXIntelResearchPanel from "./tr3ad/ux/network/intel/panels/UXIntelResearchPanel.tsx";
import UXIntelProvenancePanel from "./tr3ad/ux/network/intel/panels/UXIntelProvenancePanel.tsx";
import UXIntelTransactionsPanel from "./tr3ad/ux/network/intel/panels/UXIntelTransactionsPanel.tsx";
import UXResourceViewer from "./tr3ad/ux/network/resource/UXResourceViewer.tsx";
import UXResourceSummaryPanel from "./tr3ad/ux/network/resource/panels/UXResourceSummaryPanel.tsx";
import UXResourceTimelinePanel from "./tr3ad/ux/network/resource/panels/UXResourceTimelinePanel.tsx";
import UXResourceDetailsPanel from "./tr3ad/ux/network/resource/panels/UXResourceDetailsPanel.tsx";
import UXResourceWebRefsPanel from "./tr3ad/ux/network/resource/panels/UXResourceWebRefsPanel.tsx";
import UXResourcePagesPanel from "./tr3ad/ux/network/resource/panels/UXResourcePagesPanel.tsx";
import UXResourceSeriesPanel from "./tr3ad/ux/network/resource/panels/UXResourceSeriesPanel.tsx";
import UXResourceContentResourcesPanel from "./tr3ad/ux/network/resource/panels/UXResourceContentResourcesPanel.tsx";
import UXResourceMetadataPanel from "./tr3ad/ux/network/resource/panels/UXResourceMetadataPanel.tsx";
import UXResourceWordsPanel from "./tr3ad/ux/network/resource/panels/UXResourceWordsPanel.tsx";
import UXResourceNgramsPanel from "./tr3ad/ux/network/resource/panels/UXResourceNgramsPanel.tsx";
import UXResourceAssociationsPanel from "./tr3ad/ux/network/resource/panels/UXResourceAssociationsPanel.tsx";
import UXResourceResourcesPanel from "./tr3ad/ux/network/resource/panels/UXResourceResourcesPanel.tsx";
import UXResourceIntelRefPanel from "./tr3ad/ux/network/resource/panels/UXResourceIntelRefPanel.tsx";
import UXResourceAnalystPanel from "./tr3ad/ux/network/resource/panels/UXResourceAnalystPanel.tsx";
import UXResourceFactorsPanel from "./tr3ad/ux/network/resource/panels/UXResourceFactorsPanel.tsx";
import UXResourceEnrichmentPanel from "./tr3ad/ux/network/resource/panels/UXResourceEnrichmentPanel.tsx";
import UXResourceResearchPanel from "./tr3ad/ux/network/resource/panels/UXResourceResearchPanel.tsx";
import UXResourceProvenancePanel from "./tr3ad/ux/network/resource/panels/UXResourceProvenancePanel.tsx";
import UXResourceTransactionsPanel from "./tr3ad/ux/network/resource/panels/UXResourceTransactionsPanel.tsx";
import UXImporterSelect from "./tr3ad/ux/network/importer/UXImporterSelect.tsx";
import UXImporterConfigure from "./tr3ad/ux/network/importer/UXImporterConfigure.tsx";
import UXImporterViewer from "./tr3ad/ux/network/importer/UXImporterViewer.tsx";
import UXPublisherSelect from "./tr3ad/ux/network/publisher/UXPublisherSelect.tsx";
import UXPublisherConfigure from "./tr3ad/ux/network/publisher/UXPublisherConfigure.tsx";
import UXPublisherViewer from "./tr3ad/ux/network/publisher/UXPublisherViewer.tsx";
import UXWorkspaceSelect from "./tr3ad/ux/network/workspace/UXWorkspaceSelect.tsx";
import UXResourceSelect from "./tr3ad/ux/network/resource/UXResourceSelect.tsx";
import UXResearcher from "./tr3ad/ux/network/research/UXResearcher.tsx";
import UXResearcherCreate from "./tr3ad/ux/network/research/UXResearcherCreate.tsx";
import UXResearcherSelect from "./tr3ad/ux/network/research/UXResearcherSelect.tsx";
import UXResearcherResultSelect from "./tr3ad/ux/network/research/UXResearcherResultSelect.tsx";

let darkTheme = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: '#02cfee',
        },
        secondary: {
            main: '#38ff82',
        },
        background: {
            default: '#091920',
        },
    },
    typography: {
        fontSize: 14,
    },
    components: {
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    outline: 'none',
                    '&:focus': {
                        outline: 'none',
                        boxShadow: 'none',
                    },
                    '&:active': {
                        outline: 'none',
                        boxShadow: 'none',
                    },
                    '&.Mui-focusVisible': {
                        outline: 'none',
                        boxShadow: 'none',
                    },
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    border: 'none',
                    '&:hover': {
                        background: 'rgba(28, 242, 216, 0.08)',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    border: 'none',
                },
                contained: {
                    background: 'linear-gradient(40deg, #008F82 0%, #00476A 100%)',
                    color: '#fff',
                    '--variant-containedColor': '#fff',
                    boxShadow: 'none',
                    '&:hover': {
                        background: 'linear-gradient(155deg, #008F82 0%, #00476A 100%)',
                        boxShadow: '0 2px 8px 0 rgba(2,207,28,0.12)',
                        color: '#fff'
                    },
                    '&.Mui-disabled': {
                        background: 'rgba(255, 56, 56, 0.35)',
                        color: 'rgba(255,255,255,0.8)',
                        '--variant-containedColor': 'rgba(255,255,255,0.7)',
                    },
                },
                outlined: {
                    border: 'none',
                },
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    border: 'none',
                    '&:hover': {
                        background: 'rgba(28, 242, 216, 0.08)',
                    },
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    minHeight: 38,
                    height: 38,
                },
                indicator: {
                    backgroundColor: "#008F82", // highlight darker blue
                    height: 4,
                    borderRadius: 2,
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    // textTransform: "none",
                    fontSize: 14,
                    fontWeight: 400,
                    minHeight: 38,
                    height: 38,
                    color: "#7d96bc",
                    transition: "color 0.2s",
                    "&.Mui-selected": {
                        color: "#fff",
                        fontWeight: 500,
                    },
                }
            }
        },
    },
});

darkTheme = responsiveFontSizes(darkTheme);

function App() {

  return (
      <ThemeProvider theme={darkTheme}>
          <Stack direction="row"
                 width="100dvw" height="100dvh"
                 // minWidth={1280} height={window.innerHeight - 50}
                 marginTop={0} sx={appStyles.appContainer} >
              <BrowserRouter>
                  <Stack direction="column" spacing={0} alignItems="flex-start" justifyItems="flex-start" width="100%" minHeight={500} sx={appStyles.mainContentContainer}>
                  <AppHeader />
                      <Routes>
                          <Route path="/" element={<UXLogin />} />
                          <Route path="/reset" element={<UXLoginReset />} />
                          <Route path="/register" element={<UXRegister />} />
                          <Route path="/networks" element={<UXNetworkSelect />} />
                          <Route path="/networks/:networkUID" element={<UXNetworkHome />} />

                          {/* Dashboards */}
                          <Route path="/networks/:networkUID/dashboards" element={<UXDashboardSelect />} />
                          <Route path="/networks/:networkUID/dashboards/:dashboardUID" element={<UXDashboardViewer />} />
                          {/* Explorers */}
                          <Route path="/networks/:networkUID/explorers" element={<UXExplorerSelect />} />
                          <Route path="/networks/:networkUID/explorers/create" element={<UXExplorerCreate />} />
                          <Route path="/networks/:networkUID/explorers/:explorerUID" element={<UXExplorerViewer />} />
                          {/* Importers */}
                          <Route path="/networks/:networkUID/importers" element={<UXImporterSelect />} />
                          <Route path="/networks/:networkUID/importers/:importerUID" element={<UXImporterConfigure />} />
                          <Route path="/networks/:networkUID/importers/:importerUID/status" element={<UXImporterViewer />} />
                          {/* Intelligence */}
                          <Route path="/networks/:networkUID/intel/create" element={<UXIntelCreateSelect />} />
                          <Route path="/networks/:networkUID/intel/:typeKey/:defKey" element={<UXIntelManager />} />
                          <Route path="/networks/:networkUID/intel/:typeKey/:defKey/create" element={<UXIntelCreate />} />
                          <Route path="/networks/:networkUID/intel/:typeKey/:defKey/:matchHash" element={<UXIntelViewer />}>
                              <Route index element={<Navigate to="summary" replace />} />
                              <Route path="summary" element={<UXIntelSummaryPanel />} />
                              <Route path="timeline" element={<UXIntelTimelinePanel />} />
                              <Route path="details" element={<UXIntelDetailsPanel />} />
                              <Route path="images" element={<UXIntelImagesPanel />} />
                              <Route path="web" element={<UXIntelWebRefsPanel />} />
                              <Route path="resolvers" element={<UXIntelResolversPanel />} />
                              <Route path="assoc" element={<UXIntelAssociationsPanel />} />
                              <Route path="resources" element={<UXIntelResourcesPanel />} />
                              <Route path="insight" element={<UXIntelAnalystPanel />} />
                              <Route path="factors" element={<UXIntelFactorsPanel />} />
                              <Route path="enrichment" element={<UXIntelEnrichmentPanel />} />
                              <Route path="research" element={<UXIntelResearchPanel />} />
                              <Route path="provenance" element={<UXIntelProvenancePanel />} />
                              <Route path="transactions" element={<UXIntelTransactionsPanel />} />
                          </Route>
                          {/* Locations */}
                          <Route path="/networks/:networkUID/locations" element={<UXLocations />} />
                          {/* Publishers */}
                          <Route path="/networks/:networkUID/publishers" element={<UXPublisherSelect />} />
                          <Route path="/networks/:networkUID/publishers/:publisherUID" element={<UXPublisherConfigure />} />
                          <Route path="/networks/:networkUID/publishers/:publisherUID/status" element={<UXPublisherViewer />} />
                          {/* Reports */}
                          <Route path="/networks/:networkUID/reports" element={<UXReportSelect />} />
                          <Route path="/networks/:networkUID/reports/:reportType" element={<UXReportConfigure />} />
                          <Route path="/networks/:networkUID/reports/:reportType/:reportUID" element={<UXReportViewer />} />
                          {/* Resources */}
                          <Route path="/networks/:networkUID/resources/:typeKey" element={<UXResourceSelect />} />
                          <Route path="/networks/:networkUID/resources/:typeKey/:defKey" element={<UXResourceManager />} />
                          <Route path="/networks/:networkUID/resources/:typeKey/:defKey/:matchHash" element={<UXResourceViewer />}>
                              <Route index element={<Navigate to="summary" replace />} />
                              <Route path="summary" element={<UXResourceSummaryPanel />} />
                              <Route path="timeline" element={<UXResourceTimelinePanel />} />
                              <Route path="details" element={<UXResourceDetailsPanel />} />
                              <Route path="web" element={<UXResourceWebRefsPanel />} />
                              <Route path="pages" element={<UXResourcePagesPanel />} />
                              <Route path="series" element={<UXResourceSeriesPanel />} />
                              <Route path="content-resources" element={<UXResourceContentResourcesPanel />} />
                              <Route path="metadata" element={<UXResourceMetadataPanel />} />
                              <Route path="words" element={<UXResourceWordsPanel />} />
                              <Route path="ngrams" element={<UXResourceNgramsPanel />} />
                              <Route path="assoc" element={<UXResourceAssociationsPanel />} />
                              <Route path="resources" element={<UXResourceResourcesPanel />} />
                              <Route path="intel-ref" element={<UXResourceIntelRefPanel />} />
                              <Route path="insight" element={<UXResourceAnalystPanel />} />
                              <Route path="factors" element={<UXResourceFactorsPanel />} />
                              <Route path="enrichment" element={<UXResourceEnrichmentPanel />} />
                              <Route path="research" element={<UXResourceResearchPanel />} />
                              <Route path="provenance" element={<UXResourceProvenancePanel />} />
                              <Route path="transactions" element={<UXResourceTransactionsPanel />} />
                          </Route>
                          {/* Research */}
                          <Route path="/networks/:networkUID/research" element={<UXResearcher />} />
                          <Route path="/networks/:networkUID/research/create" element={<UXResearcherCreate />} />
                          <Route path="/networks/:networkUID/research/:researcherKey" element={<UXResearcherSelect />} />
                          <Route path="/networks/:networkUID/research/:researcherKey/results" element={<UXResearcherResultSelect />} />
                          {/* AI Analyst */}
                          <Route path="/networks/:networkUID/ai_analyst" element={<UXAIAnalyst />} />
                          {/* Graphs */}
                          <Route path="/networks/:networkUID/graphs" element={<UXGraphSelect />} />
                          <Route path="/networks/:networkUID/graphs/:graphUID" element={<UXGraphViewer />} />
                          {/* Discussions */}
                          <Route path="/networks/:networkUID/discussions" element={<UXDiscussionSelect />} />
                          <Route path="/networks/:networkUID/discussions/:topicUID" element={<UXDiscussionViewer />} />
                          {/* Search */}
                          <Route path="/networks/:networkUID/search" element={<UXSearch />} />
                          {/* Settings */}
                          <Route path="/networks/:networkUID/settings" element={<UXNetworkSettings />} />
                          <Route path="/networks/:networkUID/settings/transactions" element={<UXNetworkTransactions />} />
                          {/* Storyboards */}
                          <Route path="/networks/:networkUID/storyboards" element={<UXStoryboardSelect />} />
                          <Route path="/networks/:networkUID/storyboards/create" element={<UXStoryboardCreate />} />
                          <Route path="/networks/:networkUID/storyboards/:storyboardUID" element={<UXStoryboardViewer />} />
                          {/* Tags */}
                          <Route path="/networks/:networkUID/tags" element={<UXTagSelect />} />
                          <Route path="/networks/:networkUID/tags/:tagUID" element={<UXTagViewer />} />
                          {/* Timeline */}
                          <Route path="/networks/:networkUID/timeline" element={<UXTimeline />} />
                          <Route path="/networks/:networkUID/timeline/:year" element={<UXTimelineYear />} />
                          <Route path="/networks/:networkUID/timeline/:year/:month" element={<UXTimelineMonth />} />
                          <Route path="/networks/:networkUID/timeline/:year/:month/:day" element={<UXTimelineViewer />} />
                          {/* Workspaces */}
                          <Route path="/networks/:networkUID/workspaces" element={<UXWorkspaceSelect />} />
                          <Route path="/networks/:networkUID/workspaces/create" element={<UXWorkspaceCreate />} />

                      </Routes>
                  </Stack>
              </BrowserRouter>
          </Stack>
      </ThemeProvider>
  )
}

export default App

